import * as React from "react";

import FlightHotel from "./FlightHotel/FlightHotel";

import { PackageDealType } from "components/flexComponents/Packages/utils/PackageDealTypeEnum";

import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { PackagingFlexModuleResult } from "typings/microserviceModels/packaging-flex-module";

interface PackagesMainContentProps {
  context: ExtendedContextStore;
  model: PackagingFlexModuleResult;
}

const PackagesMainContent = (props: PackagesMainContentProps) => {
  const { context, model } = props;
  const { packageDealType } = model;

  const packagesDealTypeComponentMap = {
    [PackageDealType.FLIGHT_HOTEL]: FlightHotel,
  };

  const PackagesTypeComponent = packagesDealTypeComponentMap[packageDealType];

  return <PackagesTypeComponent context={context} model={model} />;
};

export default PackagesMainContent;
